var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"page-main"},[_c('div',{staticStyle:{"margin-top":"30px","padding":"20px"}},[_c('iframe',{style:({height: _vm.height}),attrs:{"src":_vm.frameSrc,"frameborder":"0","scrolling":"no"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }